import type { FooterLines } from '@/utils/statsFooter';

/**
 * The stats' closing footnote lines (what the last SOS / OT add brought in), each with a
 * checkbox beside it: a ticked line is added to the text Copy Stats copies, an unticked one is not.
 */
export function StatsFooterLines({
  lines, include, onChange, fontPx,
}: {
  lines: FooterLines;
  include: { sos: boolean; ot: boolean };
  onChange: (which: 'sos' | 'ot', on: boolean) => void;
  fontPx: number;
}) {
  const rows = ([['sos', lines.sos], ['ot', lines.ot]] as const).filter(([, text]) => text);
  if (rows.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, padding: '2px 8px 4px', flexShrink: 0 }}>
      {rows.map(([which, text]) => (
        <label
          key={which}
          title={include[which] ? 'Included when you copy — untick to leave it out' : 'Left out of the copy — tick to include it'}
          style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: fontPx, fontFamily: 'monospace', color: '#374151', cursor: 'pointer' }}
        >
          <input type="checkbox" checked={include[which]} onChange={(e) => onChange(which, e.target.checked)} />
          <span>{text}</span>
        </label>
      ))}
    </div>
  );
}
